import type React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ProfileLayout from './components/layout/ProfileLayout';
import Home from './pages/Home';
import ForVenues from './pages/ForVenues';
import ForPerformers from './pages/ForPerformers';
import PricingPage from './pages/PricingPage';
import About from './pages/About';
import Discover from './pages/Discover';
import PerformerProfile from './pages/PerformerProfile';
import VenueProfile from './pages/VenueProfile';
import ServiceProviderProfile from './pages/ServiceProviderProfile';
import Login from './pages/Login';
import Register from './pages/Register';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import SmsProgram from './pages/SmsProgram';
import Support from './pages/Support';
import PerformerInvitationClaim from './pages/PerformerInvitationClaim';

const App: React.FC = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/for-venues" element={<ForVenues />} />
        <Route path="/for-performers" element={<ForPerformers />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/sms" element={<SmsProgram />} />
        <Route path="/support" element={<Support />} />
        {/* Invitation claim flows. Tier-1 event access (/event/:token) lives
            on the live app since it needs authenticated claim upgrade hooks. */}
        <Route path="/invite/:token" element={<PerformerInvitationClaim />} />
      </Route>
      <Route element={<ProfileLayout />}>
        <Route path="/performer/:id" element={<PerformerProfile />} />
        <Route path="/venue/:id" element={<VenueProfile />} />
        <Route path="/service-provider/:id" element={<ServiceProviderProfile />} />
      </Route>
    </Routes>
  );
};

export default App;
